// Containers
import Landing from '../containers/Landing';
import RecentStories from '../containers/RecentStories';
import HomePage from '../containers/Home';
import StoryPage from '../containers/StoryPage';
import SettingsPage from '../containers/Settings';
import About from '../containers/About';
import Gallery from '../containers/Gallery';

import { Home, Settings, BookRounded, QuestionAnswer, PhotoAlbum } from "@material-ui/icons";

export default [
    {
        path: '/', component: Landing, exact: true
    },
    {
        path: '/storyPage',
        component: StoryPage,
    },
    {
        path: '/recentStories',
        component: RecentStories,
        text: 'Recent Stories',
        icon: BookRounded
    },   
    {
        path: '/home',
        component: HomePage,
        text: 'Home',
        icon: Home
    },
    {
        path: '/gallery',
        component: Gallery,
        text: 'Gallery',
        icon: PhotoAlbum
    },
    {
        path: '/settings',
        component: SettingsPage,
        text: 'Settings',
        icon: Settings
    },
    {
        path: '/about',
        component: About,
        text: 'About',
        icon: QuestionAnswer
    }
]